import { render, staticRenderFns } from "./basic-information-form.vue?vue&type=template&id=5c222800&scoped=true&"
import script from "./basic-information-form.vue?vue&type=script&lang=js&"
export * from "./basic-information-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c222800",
  null
  
)

export default component.exports